<template>
  <div class="AdminList">
    <box :title="$t('adminList')">
      <div class="">
        <v-data-table
          dense
          :headers="headers"
          :items="list"
          item-key=""
          @click:row="handleClick"
        >
        <template v-slot:item.AdminSectionName="{ item }">
        
        {{getAdminSectionName(item)}}
        </template>
        </v-data-table>
      </div>
    </box>
  </div>
</template>

<script>
export default {
  props: { list: Array },
  data() {
    return {
      headers: [
        {
          text: this.$t("AdminSectionCode"),
          value: "AdminSectionCode",
        },
        {
          text: this.$t("AdminSectionName"),
          value: "AdminSectionName",
        },
        {
          text: this.$t("AdminName"),
          value: "PersonName",
        },
        {
          text: this.$t("SectionName"),
          value: "Section",
        },
      ],
    };
  },
  methods: {
    getAdminSectionName(item){
        if(item.AdminSectionCode.toString().trim() == '-1' || item.AdminSectionCode == '&nbsp;'){
          return 'آزاد از گروه'
        } else{
          return item.AdminSectionName
        } 

    },
    handleClick(value) {
      this.$emit("onClickAdmin", value);
    },
  },
};
</script>

<style>
</style>